<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Content from '@/services/Content'
    import Swal from "sweetalert2";


    export default {
        components: { Layout, PageHeader},
        page: {
            title: "Videos",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                title: "Videos",
                items: [
                    {
                        text: "News",
                    },
                    {
                        text: "Videos",
                        active: true,
                        href: "/news/videos",
                    },
                ],
                showRefresh:true,
                showAlert: false,
                isBusy: false,
                isBusyButton: false,
                error: null,
                showModal:false,
                modalData:{},
                link_id:null,
                tableData: [],
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "published",
                sortDesc: true,
                fields: [
                    {
                        key: "title",
                        label: "Title",
                        sortable: true,
                    },
                    {
                        key: "videourl",
                        label: "Link",
                        sortable: false,
                    },
                    {
                        key: "image",
                        label: "Image",
                        sortable: false,
                    },
                    {
                        key: "published",
                        label: "Published Date",
                        sortable: true,
                    },
                    "action",
                ],
                  "refreshVideosBtn":false
            };
        },
        async created() {
            await this.getVideos()
            this.refreshVideosBtn = await this.checkObjectAccessCall('button.videos.refresh');
        },
        methods: {
            async getVideos(){
                try {
                    this.toggleBusy();
                    const response = await Content.getVideos()
                    this.tableData = response.data.videos
                    this.totalRows = this.tableData.length
                    this.toggleBusy();
                } catch (error) {
                    this.toggleBusy();
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                }
            },

            removeVideo(id){
                Swal.fire({
                    title: "Remove video article?",
                    text: "This video article will be removed!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Remove!",
                }).then((result) => {
                    if (result.value) {
                        try {
                            Content.removeVideos(id)
                                .then((response) => {
                                    const res = response.data ? response.data : false;
                                    const error = response.data.error ? response.data.error : 'Failed';
                                    if(res){
                                        this.getVideos()
                                        Swal.fire("Remove Video", "Video article is successfully removed!", "success");
                                    }else{
                                        Swal.fire("Fail!", error, "warning");
                                    }
                                })
                        }catch(error){
                            this.error = error.response.data.error ? error.response.data.error : "";
                        }
                    }
                });
            },

            async refreshVideos(){
                try {
                   this.isBusyButton = true;
                    const response = await Content.fireEvent({event_type: 'refresh_videos'});
                    if(response.data.data == 'refreshed') {
                        // this.getVideos();
                         this.showRefresh = false;
                         this.showAlert = true;
                           setTimeout(() => {
                               this.showAlert = false;
                               this.showRefresh = true;
                               this.getVideos();
                             }, 10000); // 10 seconds

                    }
                     this.isBusyButton = false;

                } catch (error) {
                    this.isBusyButton = false;
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                }
            },

            /**
             * Search the table data with search input
             */
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },

        },
        middleware: "authentication",
    };
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-0">
                            <div class="col-12">
                               <!-- When the Refresh Videos button is clicked, an event is triggered. Videos may not be available immediately. Timeout set before refreshing the table -->
                               <div v-if="showAlert" class="alert alert-warning" role="alert">
                                  Refresh initiated! The pulled videos will be available shortly.
                               </div>
                            </div>
                            <div v-if="showRefresh" class="col-12 text-end">
                                <a v-if="refreshVideosBtn" href="javascript:void(0);" :disabled=isBusyButton class="btn btn-success waves-effect waves-light text-end" @click="refreshVideos()">
                                    <span v-if="!isBusyButton"><i class="mdi mdi-refresh me-2"></i>Refresh Videos</span>
                                    <span v-else>Loading...</span>
                                </a>
                            </div>
                        </div>
                        <h4 class="card-title">Total Videos: {{totalRows}}</h4>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :busy="isBusy"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                                    @filtered="onFiltered"
                            >
                              <template v-slot:cell(title)="data">
                                  <p class="d-inline">{{ data.item.title }}</p>
                                  <span class="badge bg-warning ms-2" v-if="data.item.premium === 1">Premium</span>
                              </template>


                              <template v-slot:cell(videourl)="data">
                                    <a :href="data.item.videourl" target="_blank">{{data.item.videourl}}</a>
                                </template>


                                <template v-slot:cell(image)="data">
                                    <div class="flex-shrink-0">
                                        <img class="img-fluid table-images" :src="data.item.image">
                                    </div>
                                </template>


                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                            <a href="javascript:void(0);" class="px-2 text-danger" v-b-tooltip.hover title="Remove Video" @click="removeVideo(data.item.id)">
                                                <i class="uil uil-trash-alt font-size-18"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div
                                        class="dataTables_paginate paging_simple_numbers float-end"
                                >
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>